export const unmask = (value: string) => {
  return value.replace(/[^A-Za-z0-9]/g, '')
}

export const monetaryUnmask = (value: string): number => {
  const unmaskedValue = value.replace(/[^A-Za-z0-9 ]/g, '').replace(/[R ]/g, '')

  return parseFloat(unmaskedValue) / 100
}
